import React from 'react';
import { Chip } from '@mui/material';

export default function IconOnlyChip({ icon, color = 'default', onClick, sx = {}, disabled = false }) {
  return (
    <Chip
      icon={icon}
      label=""
      color={color}
      variant="outlined"
      clickable={!!onClick && !disabled}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation();
        if (onClick && !disabled) onClick(e);
      }}
      sx={{
        px: 1,
        py: 1.6,
        backgroundColor: 'transparent',
        minWidth: 'auto',
        '& .MuiChip-label': { display: 'none' },
        '& .MuiChip-icon': { fontSize: '1rem', marginLeft: 0, marginRight: 0 },
        ...sx,
      }}
    />
  );
}
